export default __webpack_public_path__ + "static/media/ig_400x400.b8663570.jpg";